// removed by extract-text-webpack-plugin
module.exports = {"footer-container":"footer-container__1tLdE","footer-links":"footer-links__2iYkD","footer-inline-links":"footer-inline-links__2WEVN","ssl-icon":"ssl-icon__3yuYj","footer-text":"footer-text__1cmZ3","link-container":"link-container__1fYOh","link-group":"link-group__1AGBg"};


//////////////////
// WEBPACK FOOTER
// ./styles/footer.scss
// module id = 704
// module chunks = 68